import React from "react";
import { Link } from "react-router-dom";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/privacy.scss";

function FAQs() {
  return (
    <main className="policy-page privacy">
      <header>
        <p className="eyebrow">Customer care</p>
        <h1>Frequently asked questions</h1>
        <p>Helpful details about orders, delivery, returns and product care.</p>
      </header>
      <section className="policy-accordions">
        <details open>
          <summary>How do I choose a size?</summary>
          <p>Each product page lists the available sizes and fit. For personal sizing advice, contact us with the item name and your usual size.</p>
        </details>
        <details>
          <summary>When will my order ship?</summary>
          <p>Orders are prepared on business days. Delivery estimates and destinations are listed in our shipping information.</p>
        </details>
        <details>
          <summary>Is shipping complimentary?</summary>
          <p>Tracked delivery is complimentary on orders over {formatPrice(siteConfig.commerce.freeShippingThreshold)}. Other orders are charged the rate shown at checkout.</p>
        </details>
        <details>
          <summary>Can I return an item?</summary>
          <p>Eligible, unworn items may be returned within {siteConfig.commerce.returnsWindowDays} days of delivery, subject to our return conditions.</p>
        </details>
        <details>
          <summary>How should I care for a garment?</summary>
          <p>Follow the care guidance shown on the product page and garment label. Our team can help with questions about a particular material.</p>
        </details>
        <details>
          <summary>How can I contact irtradeco?</summary>
          <p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> or visit our <Link to="/contact">contact page</Link>.</p>
        </details>
      </section>
    </main>
  );
}

export default FAQs;
